import { Component, OnInit } from '@angular/core';
import { LocalService, ManagerService } from '../../../../core';
import { PopupMessageService } from '../../../message/services/message.service';

@Component({
  selector: 'app-po-search',
  templateUrl: './po-search.component.html',
  styleUrls: ['./po-search.component.scss'],
})
export class PoSearchComponent implements OnInit {
  userData: any;
  poSearchText = '';
  poSearchResult: any = null;
  poSearchLoading = false;

  constructor(
    private managerService: ManagerService,
    private popupMessageService: PopupMessageService,
  ) {}

  ngOnInit() {
    this.userData = LocalService.get('userProfile');
  }

  searchPO() {
    if (!this.poSearchText) { return; }
    this.poSearchLoading = true;
    this.poSearchResult = null;
    const queryParam = {
      searchText: this.poSearchText,
      companyId: this.userData.company.id,
    };
    this.managerService.getpoSearchResult(queryParam).subscribe(
      (data:any) => {
        this.poSearchResult = data;
        this.poSearchLoading = false;
      },
      () => {
        this.poSearchLoading = false;
        this.popupMessageService.showError('PO search failed. Please try again.', 'error', 'supportCaseForm');
      }
    );
  }
}
